import React from 'react';
import { View, Text } from '@react-pdf/renderer';
const CardItemTitle = ({ title, termLabel }) => (React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center' } },
    React.createElement(Text, { style: { fontSize: '10px', letterSpacing: '0.5px', fontWeight: 'bold' } }, title),
    termLabel && (React.createElement(Text, { style: { fontSize: '10px', letterSpacing: '0.5px', fontWeight: 'bold', color: '#707070' } },
        ' ',
        termLabel))));
export default CardItemTitle;
